import { Check } from "lucide-react";

export interface Step {
  id: number;
  label: string;
}

interface Props {
  steps: Step[];
  current: number; // 1-based
}

export default function StepIndicator({ steps, current }: Props) {
  return (
    <ol
      data-testid="wc-step-indicator"
      className="flex items-center justify-center gap-2 sm:gap-4 w-full max-w-3xl mx-auto"
    >
      {steps.map((s, i) => {
        const done = s.id < current;
        const active = s.id === current;
        return (
          <li key={s.id} className="flex items-center gap-2 sm:gap-4 flex-1">
            <div className="flex flex-col items-center gap-2 min-w-[70px] sm:min-w-[110px]">
              <div
                aria-current={active ? "step" : undefined}
                className={`w-10 h-10 rounded-full grid place-items-center font-display font-bold text-base transition-colors ${
                  active
                    ? "bg-[#673dfc] text-white shadow-lg shadow-[#673dfc]/30"
                    : done
                    ? "bg-[#30265b] text-[#d3fc3a]"
                    : "bg-gray-100 text-gray-400"
                }`}
              >
                {done ? <Check size={18} /> : s.id}
              </div>
              <span
                className={`text-xs sm:text-sm font-nav font-medium text-center ${
                  active ? "text-[#30265b]" : "text-gray-500"
                }`}
              >
                {s.label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`h-1 flex-1 rounded-full mb-6 ${
                  done ? "bg-[#30265b]" : "bg-gray-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
